import styled from 'styled-components';
import { Form as FormBase } from '@unform/web';
import { device } from 'styles/device';
import { transparentize } from 'polished';
import { ButtonBase } from 'components/Button/styles';

interface FormGroupsProps {
  $columns: string;
}
interface ColumnContentProps {
  $columns: string;
  margin?: string;
}
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    display: flex;
    justify-content: space-between;
    margin: 0 1rem;
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;

export const Content = styled.div`
  header {
    display: flex;
    align-items: center;
    padding: 0 0 10px 0;
  }
  padding: 0 15px 0 15px;
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 0 15px 0 15px;
  justify-content: space-between;
  section {
    white-space: nowrap;
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const FormGroups = styled.div<FormGroupsProps>`
  grid-template-columns: ${props => props.$columns};
  display: grid;
  > div {
    &:not(:first-of-type) {
      margin-left: 5px;
    }
  }
`;

export const Exibidoras = styled.section`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;
export const VideoInfo = styled.div`
  margin-bottom: 2rem;
  > p {
    &:not(:first-of-type) {
      margin-top: 1rem;
    }
    /* margin-bottom: 2rem; */
  }
  li {
    color: ${props => props.theme.fontColor};
    font-size: 13px;
    list-style-type: disc;
    margin-left: 2rem;
  }
  footer {
    margin: 1rem 0;
    p {
      font-size: 13px;
    }
  }
`;
